/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Session {
  baseApi = ENV.BASE_API;

  async getSessionWithSlides(accessToken, sessionId, studentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}/getSessionWithSlides/${sessionId}?${studentId ? `studentId=${studentId}` : ""}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createSession(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateSession(accessToken, sessionId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}/${sessionId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateIndexWeekSessions(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}/updateIndexWeekSessions`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteSession(accessToken, sessionId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}/${sessionId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async saveSlidesSession(accessToken, sessionId, slides) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.SESSION}/saveSlidesSession/${sessionId}`;
      const formData = new FormData();
      const slidesCopy = JSON.parse(JSON.stringify(slides)); // Clonar el objeto slides

      const slidePromises = slidesCopy.map(async (slide) => {
        if (slide.content.image && slide.content.image.startsWith("blob:")) {
          const response = await fetch(slide.content.image);
          const blob = await response.blob();
          formData.append(`image-${slide._id}`, blob);
        }

        if (slide.content.audios && Array.isArray(slide.content.audios)) {
          const audioPromises = slide.content.audios.map(
            async (audio, index) => {
              if (audio.image && audio.image.startsWith("blob:")) {
                const response = await fetch(audio.image);
                const blob = await response.blob();
                formData.append(`aud-img_${index}-${slide._id}`, blob);
              }
              if (
                audio.audio &&
                audio.audio.preview &&
                audio.audio.preview?.startsWith("blob:")
              ) {
                const responseAudio = await fetch(audio.audio.preview);
                const blobAudio = await responseAudio.blob();
                formData.append(`audio_${index}-${slide._id}`, blobAudio);
              }
            }
          );
          await Promise.all(audioPromises);
        }
      });

      // Esperar a que todas las promesas se resuelvan
      await Promise.all(slidePromises);

      formData.append("slides", JSON.stringify(slidesCopy));

      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
